export const px = (value: number): string => `${value}px`;
export const px2 = (v1: number, v2: number): string => `${v1}px ${v2}px`;
export const px4 = (v1: number, v2: number, v3: number, v4: number): string =>
    `${v1}px ${v2}px ${v3}px ${v4}px`;
export const pct = (value: number): string => `${value}%`;
export const vw = (value: number): string => `${value}vw`;
export const vh = (value: number): string => `${value}vh`;
export const ms = (value: number): string => `${value}ms`;
export const rotate = (degrees: number): string => `rotate(${degrees}deg)`;
